module.exports = __webpack_public_path__ + "assets/img/a1c1-tm.svg";